// Append new API methods to api.js
import { api, setToken, clearToken, getToken, API } from "./api-core";
export { api, setToken, clearToken, getToken, API };

// Catalog
export const fetchPlatforms = () => api.get("/platforms").then(r => r.data.platforms);
export const fetchCountries = () => api.get("/countries").then(r => r.data.countries);
export const fetchLanguages = () => api.get("/languages").then(r => r.data.languages);
export const searchTitles = (params) => api.get("/search", { params }).then(r => r.data);
export const fetchTitle = (id) => api.get(`/title/${id}`).then(r => r.data);
export const fetchCinemas = (country) => api.get("/cinemas", { params: { country } }).then(r => r.data);
export const fetchTop10 = (country) => api.get("/top10", { params: { country } }).then(r => r.data);
export const fetchYouTubeReviews = (title_id) => api.get(`/title/${title_id}/yt-reviews`).then(r => r.data.results);

// Auth
export const exchangeSession = (session_id) =>
  api.post("/auth/session", { session_id }).then(r => { setToken(r.data.session_token); return r.data; });
export const fetchMe = () => api.get("/auth/me").then(r => r.data);
export const logoutApi = async () => {
  try { await api.post("/auth/logout"); } finally { clearToken(); }
  return { ok: true };
};

// Notifications
export const listNotifications = () => api.get("/notifications").then(r => r.data.notifications);
export const createNotification = (title_id, target_language = "tr") =>
  api.post("/notifications", { title_id, target_language }).then(r => r.data);
export const deleteNotification = (id) => api.delete(`/notifications/${id}`).then(r => r.data);

// Fan board
export const fetchPosts = (title_id) => api.get(`/title/${title_id}/posts`).then(r => r.data.posts);
export const createPost = (title_id, body, spoiler) =>
  api.post(`/title/${title_id}/posts`, { body, spoiler }).then(r => r.data);
export const replyToPost = (post_id, body, spoiler) =>
  api.post(`/posts/${post_id}/reply`, { body, spoiler }).then(r => r.data);

// Critic videos
export const fetchVideos = (title_id) => api.get(`/title/${title_id}/videos`).then(r => r.data.videos);
export const createVideo = (title_id, url, title, critic_name) =>
  api.post(`/title/${title_id}/videos`, { url, title, critic_name }).then(r => r.data);

// Library
export const fetchLibrary = () => api.get("/me/library").then(r => r.data);
export const updateLibrary = (title_id, status) =>
  api.post("/me/library", { title_id, status }).then(r => r.data);
export const removeFromLibrary = (title_id) =>
  api.delete(`/me/library/${title_id}`).then(r => r.data);
export const libraryStatus = (title_id) =>
  api.get(`/me/library/status/${title_id}`).then(r => r.data.status);

// Ratings
export const fetchRatings = (title_id) => api.get(`/title/${title_id}/ratings`).then(r => r.data);
export const setRating = (title_id, score) =>
  api.post(`/title/${title_id}/ratings`, { score }).then(r => r.data);

// Friends
export const fetchFriends = () => api.get("/friends").then(r => r.data);
export const requestFriend = (other_user_id) => api.post(`/friends/request/${other_user_id}`).then(r => r.data);
export const acceptFriend = (request_id) => api.post(`/friends/accept/${request_id}`).then(r => r.data);
export const rejectFriend = (request_id) => api.post(`/friends/reject/${request_id}`).then(r => r.data);
export const unfriend = (other_user_id) => api.delete(`/friends/${other_user_id}`).then(r => r.data);
export const friendSuggestions = () => api.get("/friends/suggestions").then(r => r.data.suggestions);

// Critics + public profile
export const fetchCritics = () => api.get("/critics").then(r => r.data.critics);
export const publicProfile = (user_id) => api.get(`/users/${user_id}/profile`).then(r => r.data);

// Messages
export const fetchThreads = () => api.get("/me/messages").then(r => r.data.threads);
export const fetchThread = (other_user_id) =>
  api.get(`/me/messages/${other_user_id}`).then(r => r.data);
export const sendMessage = (to_user_id, body) =>
  api.post("/me/messages", { to_user_id, body }).then(r => r.data);

// Personalized + alerts
export const fetchPersonalized = () => api.get("/me/personalized").then(r => r.data);
export const fetchAlerts = () => api.get("/me/alerts").then(r => r.data.alerts);

// Admin
export const adminBootstrap = () => api.post("/admin/bootstrap").then(r => r.data);
export const adminStats = () => api.get("/admin/stats").then(r => r.data);
export const adminListUsers = (q = "") => api.get("/admin/users", { params: q ? { q } : {} }).then(r => r.data.users);
export const adminUpdateUser = (user_id, patch) => api.patch(`/admin/users/${user_id}`, patch).then(r => r.data);
export const adminListPosts = () => api.get("/admin/content/posts").then(r => r.data.posts);
export const adminDeletePost = (id) => api.delete(`/admin/content/posts/${id}`).then(r => r.data);
export const adminListVideos = () => api.get("/admin/content/videos").then(r => r.data.videos);
export const adminDeleteVideo = (id) => api.delete(`/admin/content/videos/${id}`).then(r => r.data);
export const adminAudit = () => api.get("/admin/audit").then(r => r.data.audit);
